/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * This is a copy of polyfill.base.ts but setup to support zoneless applications
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'core-js/es/reflect';
import 'core-js/features/reflect';
import 'core-js/proposals/reflect-metadata';

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// https://www.npmjs.com/package/globalthis
// An ECMAScript spec-compliant polyfill/shim for globalThis
import 'globalthis/auto';

// Angular localize polyfill
import '@angular/localize/init';

if (typeof SVGElement.prototype.contains === 'undefined') {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}

// TODO: Figure out why our clients needs this and remove it
// Add global to window, assigning the value of window itself.
(window as any).global = window;

// TODO: Figure out why the heck webpack's bootstrap is trying to look at process
(window as any).global.process = (window as any).process || {};
(window as any).global.process.env = (window as any).global.process.env || {};
